import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query getBusinessRedemptionReport(
    $businessId: ID!
    $month: DateInput
    $teams: [ID]
    $duration: String
    $limit: Int
    $types: [BusinessRedemptionReportRedemptionType]
  ) {
    businessRedemptionReport(businessId: $businessId, month: $month, teams: $teams, duration: $duration, limit: $limit, types: $types) {
      report {
        uuid
        perks {
          dealId
          redemptions
          uniqueUsers
          type
          savingsPercentage
          savingsGBP
          savingsAUD
          estimatedSavingsGBP
          estimatedSavingsAUD
          brandName
          header
          internalIdentifier
        }
      }
      availableDates {
        month
        year
        quarter
      }
    }
  }
`

export const businessRedemptionReportKey = getQueryNames(query)[0]

export default query
